import createComponent from '@carvana/merch-components/createComponent';
import cx from 'classnames';

export const MapLegendSearchAreaContainer = createComponent('div', {
  className: cx(
    'absolute left-0 top-0 lg:left-[5%] lg:top-[50px]',
    'flex flex-col sm:flex-row lg:flex-col',
    'w-full overflow-hidden lg:w-[350px] lg:rounded-t-sm',
    'bg-blue-4'
  )
});

export const MapLegendSearchAreaHeader = createComponent('div', {
  className: cx(
    'inline-flex flex-col items-center gap-16 sm:flex-row sm:items-start lg:flex-col lg:items-center',
    'w-full p-32 pb-24 sm:w-1/2 sm:pb-32 lg:w-full lg:pb-24',
    'text-2xl leading-[26px]'
  )
});

export const MapLegendSearchAreaHeaderText = createComponent('h2', {
  className:
    'font-brandon text-center font-bold uppercase text-white sm:mb-0 sm:text-left lg:text-center'
});

export const MapLegendSearchAreaInputWrapper = createComponent('div', {
  className:
    'inline-block w-full px-16 pb-32 sm:w-1/2 sm:pt-32 lg:w-full lg:pt-0'
});

export const MapLegendListContainer = createComponent('div', {
  className:
    'absolute bottom-0 left-0 w-full text-center lg:left-[5%] lg:top-[288px] lg:w-[350px]'
});

export const LegendLocations = createComponent('div', {
  className: cx(
    'absolute bottom-32 left-0 lg:bottom-auto',
    'flex flex-1 flex-row lg:flex-col',
    'w-full pl-24 lg:max-h-[60dvh] lg:w-full lg:rounded-b-sm lg:pl-0',
    'no-scrollbar overflow-x-scroll lg:overflow-x-hidden lg:overflow-y-scroll',
    'lg:bg-white'
  )
});

export const LegendLocationItemInnerContainer = createComponent('div', {
  className: 'm-20 min-h-[4em] text-left text-[#757989]'
});

export const LegendLocationItemTitle = createComponent('div', {
  className: 'text-base font-bold text-blue-6'
});

export const LegendLocationItemAddress = createComponent('div', {
  className: 'ml-24 cursor-pointer text-sm'
});

export const LegendLocationItemDistance = createComponent('div', {
  className: 'absolute right-24 top-20 text-sm'
});
